import { StandardEvents } from '@shopify/events';

/* Buy now uses the existing product form and its variant/quantity/error handling. */
class SGDirectCheckout extends HTMLElement {
  #abort;
  #observer;
  #busy = false;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    this.addEventListener('click', this.#checkout, { signal: this.#abort.signal });
    const component = this.closest('product-form-component');
    if (!component) return;
    this.#observer = new MutationObserver(this.#sync);
    this.#observer.observe(component, { attributes:true, attributeFilter:['disabled'], childList:true, subtree:true });
    this.#sync();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#observer?.disconnect();
  }

  #sync = () => {
    const component = this.closest('product-form-component');
    const add = component?.querySelector('button[name="add"]');
    const button = this.querySelector('button');
    if (!add || !button) return;
    const disabled = this.#busy || add.disabled;
    if (button.disabled !== disabled) button.disabled = disabled;
  };

  #checkout = (event) => {
    if (!event.target.closest('button')) return;
    event.preventDefault();
    event.stopPropagation();
    if (this.#busy) return;
    const component = this.closest('product-form-component');
    const form = component?.querySelector('form');
    const add = component?.querySelector('button[name="add"]');
    const button = this.querySelector('button');
    if (!component || !form || !add || !button || add.disabled || !form.reportValidity()) return;
    const validation = component.refs?.quantitySelector?.canAddToCart?.();
    if (validation && !validation.canAdd) { add.click(); return; }
    this.#busy = true;
    this.setAttribute('aria-busy', 'true');
    const label = button.textContent;
    button.textContent = this.dataset.pendingLabel;
    this.#sync();
    const restore = () => {
      this.#busy = false;
      this.removeAttribute('aria-busy');
      button.textContent = label;
      const scope = component.closest('product-component') || component.closest('.product-details') || component;
      const options = [...scope.querySelectorAll('variant-picker input:checked')];
      const hasSizes = scope.querySelector('variant-picker input[data-option-name="Size"]');
      const chosenSize = scope.querySelector('variant-picker input[data-option-name="Size"]:checked');
      add.disabled = options.some(input => input.dataset.optionAvailable === 'false') || Boolean(hasSizes && !chosenSize);
      this.#sync();
    };
    const onCartUpdate = (cartEvent) => {
      if (cartEvent.target !== component || !cartEvent.promise) return;
      component.removeEventListener(StandardEvents.cartLinesUpdate, onCartUpdate);
      cartEvent.stopPropagation();
      add.disabled = true;
      cartEvent.promise.then(({ detail }) => {
        if (detail?.didError) { restore(); return; }
        window.location.assign(this.dataset.checkoutUrl);
      }).catch(restore);
    };
    component.addEventListener(StandardEvents.cartLinesUpdate, onCartUpdate);
    try { form.requestSubmit(add); }
    catch (error) {
      component.removeEventListener(StandardEvents.cartLinesUpdate, onCartUpdate);
      restore();
    }
  };
}

if (!customElements.get('sg-direct-checkout')) customElements.define('sg-direct-checkout', SGDirectCheckout);
